const IGeocodeService = require('../../IGeocodeService');
const CRSTransformUtil = require('../../../../utils/CRSTransformUtil');
const g2 = require('../../../../g2');
/**
 * @classdesc 高德地理编码服务
 * @alias G.service.GeocodeGaodeServiceImpl
 * @augments G.service.IGeocodeService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 * @param opts.token {String} 调用令牌
 */
class GeocodeGaodeServiceImpl extends IGeocodeService {
    constructor(opts) {
        super(opts);
        this.options = {};
        for (let k in opts) {
            this.options[k] = opts[k];
        }
        this.coordUtil = G.utils.CoordUtil;
        this.projectService = new g2.sfs.CoordinateTransform();
    }
    /**
     * @inheritdoc
     */
    getAddressByKeyword(opts) {
        const pageSize = opts.pageSize || 10;
        const pageIndex = opts.pageIndex || 1;
        const keyWord = opts.keyWord;
        return new Promise((resolve, reject) => {
            try {
                const url = `${this.options.url}/place/text?key=` + this.options.token + '&keywords=' + keyWord + '&offset=' + pageSize + '&page=' + pageIndex;
                this.options.httpRequest.get(url, 'json', null, 'application/x-www-form-urlencoded', {}).then(data =>{
                    resolve(data);
                }).catch(err => {
                    reject(err);
                });             
            } catch (error) {
                reject(error);
            }
        })
    }
    /**
     * @inheritdoc
     */
    getAddressByLocation(opts) {
        const radius = opts.radius || 1000;
        const spatialReference = opts.spatialReference || 4326;
        return new Promise((resolve, reject) => {
            try {
                let location = opts.location;
                location = this._getTransformedCoordiante(location, spatialReference);                  
                const url =  `${this.options.url}/geocode/regeo?key=` + this.options.token + '&location=' + location.join(',') + '&radius=' + radius + '&extensions=base';
                this.options.httpRequest.get(url, 'json', null, 'application/x-www-form-urlencoded', {}).then(data =>{

                    data.result = data.regeocode;
                    data.msg = data.info;
                    resolve(data);
                }).catch(err => {
                    reject(err);
                });         
            } catch (error) {
                reject(error);
            }
        })
    } 

    _getTransformedCoordiante(point, spatialReference) {
        let resultPoint = [];
        switch (spatialReference) {
            case 4326:
                {
                    let transformed = CRSTransformUtil.wgs84togcj02([point[1], point[0]].join(','));
                    resultPoint[0] = parseFloat(transformed.split(',')[0]).toFixed(6);
                    resultPoint[1] = parseFloat(transformed.split(',')[1]).toFixed(6);
                    break;
                }
            case 3857:
                {
                    let geom = new g2.sfs.Point({
                        x: pint[0],
                        y: point[1],
                        spatialReference: 3857
                    });
                    let geom4326 = this.projectService.transform(geom, 4326);
                    resultPoint = this._getTransformedCoordiante([geom4326.x, geom4326.y], 4326);
                    break;
                }
            default:
                {
                    break;
                }
        }
        return resultPoint;
    }
}
module.exports = GeocodeGaodeServiceImpl;